import React, { FC } from 'react';
import { PictureProps } from '../../atoms/Picture';
import { LinkProps } from '../../atoms/Link';
import { ActionButtonProps } from '../../atoms/ActionButton';
import * as SC from './styled';
export type BrandPushProps = MinimalSeoBlock & {
  className?: string;
  imageProps?: PictureProps;
  brandLogoProps?: PictureProps;
  brandName?: string;
  brandLabel?: string;
  actionButtonProps?: ActionButtonProps;
  productsProps?: {
    name?: string;
    imageProps: PictureProps;
    linkProps?: LinkProps;
    label?: string;
  }[];
};
const BrandPush: FC<BrandPushProps> = ({
  className,
  htmlTag,
  htmlTitleTag,
  imageProps,
  brandLogoProps,
  brandLabel,
  brandName,
  actionButtonProps,
  productsProps
}) => {
  return <SC.Main className={className} as={htmlTag}>
      <SC.Brand {...actionButtonProps}>
        {imageProps && <SC.BackgroundImage {...imageProps} />}
        <SC.BrandContent as={htmlTitleTag}>
          {brandLogoProps && <>
              <SC.LogoContainer aria-hidden>
                <SC.Logo {...brandLogoProps} width={120} height={120} />
              </SC.LogoContainer>
            </>}
          {(brandLabel || brandName) && <SC.BrandHeader>
              {brandLabel && <SC.BrandLabel>{brandLabel}</SC.BrandLabel>}
              {` `}
              {brandName && <SC.BrandName>{brandName}</SC.BrandName>}
            </SC.BrandHeader>}
          {actionButtonProps && <SC.Button {...actionButtonProps} href={undefined} onClick={() => null} />}
        </SC.BrandContent>
      </SC.Brand>
      {productsProps?.map((productProps, i) => <SC.Product {...productProps?.linkProps} key={i}>
          <>
            {productProps?.imageProps && <SC.ProductImage {...productProps?.imageProps} />}
            <SC.ProductContent>
              {productProps?.name && <SC.ProductName>{productProps?.name}</SC.ProductName>}
              {productProps?.label && <SC.ProductLabel>{productProps?.label}</SC.ProductLabel>}
            </SC.ProductContent>
          </>
        </SC.Product>)}
    </SC.Main>;
};
export default BrandPush;